import { Button, Card, Image, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PhotoService from "../../../../service/PhotoService";
import AddPhoto from "./AddPhoto";
// import EditPhoto from "./EditPhoto";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_IMG_URL } from "../../../../configs/AppConfig";

const { confirm } = Modal;

const Photo = () => {
  const [openAdd, setOpenAdd] = useState({
    open: false,
    storyId: "",
  });

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    storyId: "",
  });
  const [Photo, setPhoto] = useState<any>([]);
  const [newPhotoId, setNewPhotoId] = useState("");

  const showDrawerAdd = async () => {
    setOpenAdd({
      open: true,
      storyId: "",
    });
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, storyId: record._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await PhotoService.fetchFilter(1);

      setPhoto({
        data: result.data.photos,
        total: result.data.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "图片",
      dataIndex: "img",
      key: "img",
      width: "70%",

      render: (text: string, record: any) => (
        <>
          <Image width={200} src={API_IMG_URL + text} />
        </>
      ),
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deletePhotoConfirm(record._id);
              }}
            >
              删除
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await PhotoService.fetchFilter(page);
    setPhoto({
      data: res.data.photos,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deletePhoto = async (id: string) => {
    await PhotoService.delete(id);
    window.location.reload();
  };

  const deletePhotoConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deletePhoto(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={Photo.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: Photo.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && <AddPhoto openData={openAdd} setOpenData={setOpenAdd} />}
      {/* {openEdit.open && (
        <EditPhoto openData={openEdit} setOpenData={setOpenEdit} />
      )} */}
    </Card>
  );
};

export default Photo;
